import {Routes} from "@angular/router";
import {LegalComponent} from "./legal/legal.component";
import {MAILING_LEGAL_ROUTES} from "./legal/legal.routes";

export enum MailingRoutes {
  Legal = 'legal'
}

export const MAILING_ROUTES: Routes = [
  {
    path: MailingRoutes.Legal,
    component: LegalComponent,
    children: MAILING_LEGAL_ROUTES
  },
  {
    path: '**', redirectTo: '/', pathMatch: 'full'
  }
]
